import { ReactElement, ReactNode } from 'react';
import styles from './ui-sidebar.module.scss';

type UISidebarProps = {
    children?: ReactNode;
    collapsed?: boolean;
};
export function UISidebar(props: UISidebarProps): ReactElement {
    const { children, collapsed } = props;
    const style = [styles.container];
    if (collapsed) {
        style.push(styles.collapsed);
    } else {
        style.push(styles.expanded);
    }
    return <nav className={style.join(' ')}>{children}</nav>;
}
